import React from 'react';
import { Star } from 'lucide-react';

interface ShinyIndicatorProps {
  isShiny?: boolean;
  size?: 'small' | 'medium' | 'large';
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  className?: string;
}

const ShinyIndicator: React.FC<ShinyIndicatorProps> = ({
  isShiny = false,
  size = 'small',
  position = 'top-right',
  className = ''
}) => {
  if (!isShiny) return null;

  const sizeMap = {
    small: 'w-4 h-4',
    medium: 'w-5 h-5',
    large: 'w-6 h-6'
  };

  const positionMap = {
    'top-right': 'top-0 right-0',
    'top-left': 'top-0 left-0',
    'bottom-right': 'bottom-0 right-0',
    'bottom-left': 'bottom-0 left-0'
  };

  return (
    <div className={`absolute ${positionMap[position]} ${className} z-10`}>
      <div className="relative">
        {/* Étoile principale */}
        <Star 
          className={`${sizeMap[size]} text-yellow-400 fill-yellow-300 relative z-10`}
          style={{
            filter: 'drop-shadow(0 0 3px rgba(251, 191, 36, 0.9))'
          }}
        />
        
        {/* Petites particules autour */}
        <div className="absolute -top-1 -right-1 w-1 h-1 bg-yellow-300 rounded-full animate-ping" 
             style={{ animationDelay: '0ms' }} />
        <div className="absolute -bottom-1 -left-1 w-1 h-1 bg-yellow-300 rounded-full animate-ping" 
             style={{ animationDelay: '500ms' }} />
      </div>
    </div>
  );
};

export default ShinyIndicator;